export default __webpack_public_path__ + "static/3-0749e910313e53f470a1c38db8878d65.png";